import { type TDescendant, type TEditor, createPluginFactory, removeNodes } from "@udecode/plate";

import { getSelectedFullTable } from "../components/decisionTable/tableClipboard";

/**
 * Keep this override after section/table plugins. If a cut selection spans the
 * whole visual table, remove the table node directly before Slate's default
 * deleteFragment strips row contents and leaves an invalid skeleton table.
 */
export const withRuleEditorFullTableDelete = <T extends TEditor>(editor: T) => {
  const { deleteFragment } = editor;

  editor.deleteFragment = (...args: any[]) => {
    let fragmentBeforeDelete: TDescendant[] | null = null;
    try {
      fragmentBeforeDelete = editor.getFragment() as TDescendant[];
    } catch (_error) {
      fragmentBeforeDelete = null;
    }

    const selectedFullTable = Array.isArray(fragmentBeforeDelete)
      ? getSelectedFullTable(editor as any, fragmentBeforeDelete)
      : null;

    if (selectedFullTable) {
      removeNodes(editor, { at: selectedFullTable.tablePath });
      return;
    }

    return deleteFragment(...args);
  };

  return editor;
};

export const createRuleEditorFullTableDeletePlugin = createPluginFactory({
  key: "rule-editor-full-table-delete",
  withOverrides: withRuleEditorFullTableDelete,
});
